<script>
import { mapMutations } from 'vuex'

import { namespace as gnbNamespace, types as gnbTypes } from '../../../store/modules/gnb-store'

export default {
  methods: {
    ...mapMutations(gnbNamespace, [gnbTypes.SET_HOVER_MENU]),
    imagePath(filePath, isInternalFile) {
      if (isInternalFile) {
        return `${this.getDomain('cdn')}/resources/img/${filePath}`
      } else {
        return filePath
      }
    },
    hoverMenu(menu, hover) {
      this.setHoverMenu({
        menu,
        hover
      })
    }
  }
}
</script>
